import {
    CheckCircleOutlined,
    LoadingOutlined,
    CarOutlined,
    InboxOutlined,
    SendOutlined,
    RocketOutlined,
    GlobalOutlined,
    AuditOutlined,
    WalletOutlined,
    SyncOutlined,
    BankOutlined,
} from "@ant-design/icons";

export const PROSES_ORDER_BARANG = {
    "01": 1,
    "02": 2,
    "03": 3,
    "04": 4,
    "05": 5,
    "06": 6,
    "07": 7,
    "08": 8,
    "09": 9
};

export const statusConfigBarang = {
    "01": {
        color: "blue",
        icon: <LoadingOutlined spin />,
        label: "Order Received",
        explain: "Order received and processing. We will notify you once your package is shipped."
    },
    "02": {
        color: "orange",
        icon: <InboxOutlined />,
        label: "Package Prepared",
        explain: "Your package is being prepared for shipment. We will provide you with a tracking number soon."
    },
    "03": {
        color: "orange",
        icon: <SendOutlined />,
        label: "Shipped",
        explain: (record) => `Your package has been shipped via INDAK with tracking number ${record.noResi}.`
    },
    "04": {
        color: "orange",
        icon: <CarOutlined />,
        label: "In Transit to Airport",
        explain: (record) => `Your package is in transit to the airport and will be flown to ${record.TujuanNegara} soon.`
    },
    "05": {
        color: "orange",
        icon: <RocketOutlined />,
        label: "Departed Indonesia",
        explain: (record) => `Your package has departed Indonesia and is on its way to ${record.TujuanNegara}.`
    },
    "06": {
        color: "orange",
        icon: <GlobalOutlined />,
        label: "Arrived at Destination Airport",
        explain: (record) => `Your package has arrived at ${record.TujuanNegara}'s Airport and is being processed by customs.`
    },
    "07": {
        color: "orange",
        icon: <AuditOutlined />,
        label: "Customs Clearance",
        explain: (record) => `Your package is undergoing customs clearance in ${record.TujuanNegara}. This may take a few days.`
    },
    "08": {
        color: "orange",
        icon: <CarOutlined />,
        label: "Out for Delivery",
        explain: "Your package has cleared customs and is out for delivery to your address."
    },
    "09": {
        color: "green",
        icon: <CheckCircleOutlined />,
        label: "Delivered",
        explain: "Your package has been delivered to your address. Thank you for your order!"
    }
};

export const PROSES_ORDER_UANG_OUT = {
    "01": 1,
    "02": 2,
    "03": 3,
    "04": 4,
    "05": 5,
    "06": 6,
    "07": 7
};

export const statusConfigUangOut = {
    "01": {
        color: "blue",
        icon: <LoadingOutlined spin />,
        label: "Transaction Initiated",
        explain: (record) => `Dear valued client, Salam Service has initiated your international money transfer to ${record.namaPenerima} in ${record.TujuanNegara}. Reference number: ${record.noResi}.`
    },
    "02": {
        color: "orange",
        icon: <WalletOutlined />,
        label: "Funds Received",
        explain: "We have received and verified the funds for your transfer. Our team is processing the transaction."
    },
    "03": {
        color: "orange",
        icon: <SyncOutlined spin />,
        label: "Processing",
        explain: "Your transfer is being processed by our international payment team. Estimated delivery time: [Estimated Time]."
    },
    "04": {
        color: "orange",
        icon: <SendOutlined />,
        label: "Sent to Correspondent Bank",
        explain: (record) => `Funds have been sent to our correspondent bank, [Correspondent Bank Name], in ${record.TujuanNegara}. Tracking number: ${record.noResi}.`
    },
    "05": {
        color: "orange",
        icon: <BankOutlined />,
        label: "Received by Correspondent Bank",
        explain: "Our correspondent bank, [Correspondent Bank Name], has received the funds and is processing payout to the recipient's bank account."
    },
    "06": {
        color: "orange",
        icon: <SyncOutlined spin />,
        label: "Payout Processing",
        explain: "The recipient's bank is processing the payout. You will receive a notification once the transaction is complete."
    },
    "07": {
        color: "orange",
        icon: <CheckCircleOutlined />,
        label: "Paid Out",
        explain: (record) => `Funds have been paid out to the recipient's bank account. Transaction complete. Reference number: ${record.noResi}.`
    },
};

export const PROSES_ORDER_UANG_IN = {
    "01": 1,
    "02": 2,
    "03": 3,
    "04": 4,
    "05": 5,
    "06": 6
};

export const statusConfigUangIn = {
    "01": {
        color: "blue",
        icon: <LoadingOutlined spin />,
        label: "Transaction Initiated",
        explain: (record) => `Dear valued client, Salam Service has received an international money transfer in your favor from ${record.namaPengirim} in ${record.asalNegara}. Reference number: ${record.noResi}.`
    },
    "02": {
        color: "orange",
        icon: <BankOutlined />,
        label: "Funds Received by Correspondent Bank",
        explain: (record) => `Our correspondent bank, [Correspondent Bank Name], has received the funds and is processing transfer to our bank in Indonesia.`
    },
    "03": {
        color: "orange",
        icon: <SendOutlined />,
        label: "Funds Sent to Indonesia",
        explain: (record) => `Funds have been sent to our bank in Indonesia and are being processed for payout to your account.`
    },
    "04": {
        color: "orange",
        icon: <WalletOutlined />,
        label: "Received by Salam Service",
        explain: (record) => `We have received the funds and are processing payout to your account.`
    },
    "05": {
        color: "orange",
        icon: <SyncOutlined spin />,
        label: "Processing",
        explain: (record) => `Your funds are being processed for payout. Estimated credit time: [Estimated Time].`
    },
    "06": {
        color: "orange",
        icon: <CheckCircleOutlined />,
        label: "Paid Out",
        explain: (record) => `Funds have been credited to your account. Transaction complete. Reference number: ${record.noResi}.`
    },
}